export default "__VITE_ASSET__jFauSky1__"